import React from 'react'
import PropTypes from 'prop-types'

import { translate, utils } from 'parking-react-common'

import Panel from '../components/Panel'
import Table from '../components/Table'

const FixedDurationsListForm = (props) => {
    const { item, t } = props

    const columns = [
        {
            key   : 'duration',
            title : t('Duration')
        },
        {
            key    : 'price',
            title  : t('Price'),
            render : ({ cellData }) => utils.formatAmountWithUnit(cellData, item.currency)
        }
    ]

    return (
        <Panel
            title={ t('Fixed Priced Intervals') }
            hasTable
        >
            <Table
                columns={ columns }
                data={ item.fixed_durations }
            />
        </Panel>
    )
}

FixedDurationsListForm.propTypes = {
    item: PropTypes.object.isRequired
}

export default translate()(FixedDurationsListForm)
